import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, IKeyValueInterface } from '../../shared/config';
import { UserProfileService } from '../models/userprofile.service';
import { ChangePasswordModel } from '../models/changepassword.model';


@Component({
  selector: 'wego-userprofile-changepassword',
  template: require('../views/userprofile-changepassword-popup.component.html'),
})

export class ChangePasswordPopupComponent implements OnInit {
  model: ChangePasswordModel;
  DataListModel: DataListModel;
  message: string;
  apiErrorMsg: string;
  urlPersonUpdate: string;
  isLoading: boolean;
  errorModel: IKeyValueInterface[];
  errorMessage: string;
  public personHashId: string;
  @Output('OnSuccessUpdatePassword') onSuccessSelect = new EventEmitter();
  @ViewChild('changePasswordModal') public changePasswordModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(private personService: UserProfileService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.translate.setDetectedLang();
    this.DataListModel = new DataListModel();
    this.urlPersonUpdate = this.authService.GetURL(ApplicationRouteURL.URL_PERSON_UPDATE);
    this.model = new ChangePasswordModel();
    this.model.personHashId = this.personHashId;
  }

  onSubmit(forms: any) {
    console.log(this.model);
    console.log(this.personHashId);
    this.model.personHashId = this.personHashId;
    this.SubmitChangePassword();
  }


  public show(): void {
    this.changePasswordModal.show();
  }

  public hide(): void {
    this.changePasswordModal.hide();
    this.model = new ChangePasswordModel();
    this.errorMessage = '';
    this.message = '';
    this.errorModel = null;
  }

  public SubmitChangePassword() {
    this.personService.SubmitChangePassword(this.model)
      .subscribe(
      res => {
        if (res.data == null) {
          this.message = this.translate.instant('LblPasswordChangedSucessFully');
          this.OnSuccessUpdatePassword();
          this.hide();
        }
        else {
          this.errorMessage = res.data;
          this.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
      );
  }

  private OnSuccessUpdatePassword() {
    this.onSuccessSelect.emit({ SuccessMessage: this.message })
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/userprofile/components/changepassword-popup.component.ts